import axios from 'axios';
var isRefreshing = false;
var failedQueue = [];
var processQueue = function (error, token) {
    if (token === void 0) { token = null; }
    failedQueue.forEach(function (prom) {
        if (error) {
            prom.reject(error);
        }
        else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};
var interceptor = function (baseUrl, axiosInstance, ClearLocalStorage) {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    return function (error) {
        if ('Network Error' === error.message) {
            return Promise.reject(error);
        }
        if (error.response.status === 403 &&
            window.location.pathname !== '/change-password') {
            ClearLocalStorage();
            window.location.href = '/#/login';
            return Promise.reject(error);
        }
        var _axios = axiosInstance;
        var originalRequest = error.config;
        if (error.response.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return new Promise(function (resolve, reject) {
                    failedQueue.push({ resolve: resolve, reject: reject });
                })
                    .then(function () {
                    var oauth = localStorage.getItem('oauth');
                    if (null === oauth) {
                        return Promise.reject('Oauth not found in localstorage');
                    }
                    var oauthJson = JSON.parse(oauth);
                    if (null === oauthJson) {
                        return Promise.reject('Oauth is not JSON in localstorage');
                    }
                    originalRequest.headers['Authorization'] =
                        'Bearer ' + oauthJson.accessToken;
                    return _axios.request(originalRequest);
                })
                    .catch(function (err) {
                    return Promise.reject(err);
                });
            }
            originalRequest._retry = true;
            isRefreshing = true;
            var oauth = localStorage.getItem('oauth');
            if (null === oauth) {
                return Promise.reject('Oauth not found in localstorage');
            }
            var oauthJson_1 = JSON.parse(oauth);
            var viewAs_1 = localStorage.getItem('viewAs');
            // Create a new axios instance for the refresh token request
            var refreshAxios_1 = axios.create();
            return new Promise(function (resolve, reject) {
                refreshAxios_1
                    .post(baseUrl + '/oauth/refresh', {
                    grantType: 'refresh',
                    clientId: oauthJson_1.clientId,
                    clientSecret: oauthJson_1.clientSecret,
                    refreshToken: oauthJson_1.refreshToken,
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer ".concat(oauthJson_1.accessToken),
                        'X-View-As': viewAs_1,
                    },
                })
                    .then(function (_a) {
                    var data = _a.data;
                    var oauth = localStorage.getItem('oauth');
                    if (null === oauth) {
                        return Promise.reject('Oauth not found in localstorage');
                    }
                    var oauthJson = JSON.parse(oauth);
                    oauthJson.accessToken = data.oauth.accessToken;
                    oauthJson.expiresAt = data.oauth.expiresAt;
                    oauthJson.expiresIn = data.oauth.expiresIn;
                    oauthJson.refreshToken = data.oauth.refreshToken;
                    localStorage.setItem('oauth', JSON.stringify(oauthJson));
                    _axios.defaults.headers.common['Authorization'] =
                        'Bearer ' + data.oauth.accessToken;
                    originalRequest.headers['Authorization'] =
                        'Bearer ' + data.oauth.accessToken;
                    processQueue(null, data.token);
                    resolve(_axios(originalRequest));
                })
                    .catch(function (err) {
                    processQueue(err, null);
                    reject(err);
                    ClearLocalStorage();
                    window.location.href = '/#/login';
                })
                    .then(function () {
                    isRefreshing = false;
                });
            });
        }
        return Promise.reject(error);
    };
};
export default interceptor;
